import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Lost a freelance project, but gained a knowledge",
  "description": "",
  "published": "2009-12-02T00:00:00.000Z",
  "redirect_from": ["/blog/lost-a-freelance-project-but-gained-a-knowledge/swizec/932"],
  "categories": "Communication, Employment, food for thought, freelancing, life, Scientific method, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/14418824@N04/4153364026/"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/4153364026_fa218c6d0c_m.jpg",
              "alt": "Rall",
              "title": "Rall"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/14418824@N04/4153364026/"
          }}>{`Alberto Casanova`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`For the past month I've been working on a freelance project shoved between all my other responsibilities because I felt I needed some sort of cashflow. But yesterday said project went poof and I'll probably never get to work with that company again, over the phone it sounded like there was some bad blood between us, but because of how they led the conversation I didn't feel like prodding and finding out what specifically went so poorly.`}</p>
    <p>{`However, I know exactly why I lost the project, poor communication on mostly my part and an extreme lack of proper time to devote to the work. But none of this really matters, the reasons are arbitrary and I'm sure the client would put forth completely different reasons and I'm very certain in my career I'll lose countless projects and gain countless others. What matters is what I learned from the experience.`}</p>
    <h3 {...{
      "id": "1-negotiate-a-clear-deadline"
    }}>{`1. Negotiate a clear deadline`}</h3>
    <p>{`Working under the assumption that the project needs to be finished when it's done, while the other side expects you to finish in a month is very problematic. The biggest problem here being that without a deadline you're naturally inclined to give it your 100% very bestest effort, which leads to over-engineering and too much pedantry and just plain old producing something they don't really want.`}</p>
    <h3 {...{
      "id": "2-clearly-very-clearly-negotiate-the-time-youve-got"
    }}>{`2. Clearly very clearly negotiate the time you've got`}</h3>
    <p>{`Certainly I told the client, hey, I've got 10, at best 15, hours of time every week to work on this project. Most of this will be during weekends. And of course they agreed. But I don't think they realised just how serious I was about this constraint (has happened to me before). So next time dear freelancing Swizec, make very extremely 100% fucking certain both sides know what you are able to bring to the table.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/26106682@N02/4152708765/"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/4152708765_0c04d2b380_m.jpg",
              "alt": "Rainy Angel",
              "title": "Rainy Angel"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/26106682@N02/4152708765/"
          }}>{`Lillou Merlin ~ On ~ Off`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "3-listen-to-your-intuition-knowledge"
    }}>{`3. Listen to your `}<a parentName="h3" {...{
        "href": "http://en.wikipedia.org/wiki/Intuition_%28knowledge%29",
        "title": "Intuition (knowledge)"
      }}>{`gut feeling`}</a></h3>
    <p>{`When your gut smells something suspicious, it's usually right. I won't go into specifics as to what the smells were and just how bloody early into the conversation I knew this wasn't going to be a perfect fit, but I did know, and I didn't listen, because I thought that `}<em parentName="p">{`meh, I'll make it work somehow.`}</em></p>
    <p>{`_`}{`_`}{`I didn't.`}</p>
    <h3 {...{
      "id": "4-negotiate-who-theyre-hiring"
    }}>{`4. Negotiate who they're hiring`}</h3>
    <p>{`Now I won't go so far as to say this was the problem here, but I've had a similar issue once before. Sometimes when people hire a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Freelancer",
        "title": "Freelancer"
      }}>{`freelancer`}</a>{`, they actually want an employee and all the perks that come with that. Well, you have to negotiate this in advance, otherwise both sides just end up being disappointed.`}</p>
    <h3 {...{
      "id": "5-make-sure-they-know-in-advance-when-youre-down"
    }}>{`5. Make sure they know in advance when you're down`}</h3>
    <p>{`Apparently not everyone is going to like it when you stop your life for a week to take care of exams, midterms and such things at school. They might not realise this is important stuff, but it is. In the past I didn't use to do this, but I've learned the hard way that NOTHING and I mean absolutely `}<em parentName="p">{`nothing`}</em>{` is more important than school.`}</p>
    <h3 {...{
      "id": "6-how-you-know-youve-not-lost-much"
    }}>{`6. How you know you've not lost much`}</h3>
    <p>{`If, upon breaking up with you, the client calls you names - yes even calling someone arrogant is calling them names - then they're sending a clear message to that the relationship breaking up is rather a good thing than a bad thing. Yep, even when they're just doing it as an emotional response and a rationalisation for breaking up.`}</p>
    <p>{`And commenting someone's work with`}<em parentName="p">{` "We'll try to use what you make, but I doubt it's possible since it's all crap"`}</em>{` ... seriously man? Seriously? I may not be on the level of someone who builds software for NASA or Google, but I am in fact a professional in my field and have a certain amount of empirical data to prove that my work is not, in fact, useless.`}</p>
    <p>{`Civil conduct, it matters!`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/35443956@N00/2312957360"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/2312957360_7394ec5f6c_m.jpg",
              "alt": "information flow @google 5",
              "title": "information flow @google 5"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/35443956@N00/2312957360"
          }}>{`info_aesthetics`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "the-good-stuff-is-more-important"
    }}>{`The good stuff is more important!`}</h3>
    <p>{`But most importantly, I got to work with a fucking brilliant developer. He knows who he is and I do hope he'll continue reading my blog despite my having left him with a bit of mess to clean up - it's not a big mess, but unfinished code is always a mess - he was very great throughout the whole process, very helpful and very good with showing me around their `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Codebase",
        "title": "Codebase"
      }}>{`codebase`}</a>{`. Yep, despite this being supposedly his first shot at it.`}</p>
    <p>{`Oh and did I mention that he designed a very brilliant framework? I've been into web frameworks since 2004 and I know very well when I spot something well designed. Kudos man.`}</p>
    <p>{`Needless to say that if I'm ever in the position of poaching this person I am SO doing it, without a second thought. Mine! At the very least I hope we can remain in good relations ...`}</p>
    <p>{`And that's all I've got to say on the matter, thank you for the lesson dear client who shall remain nameless.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/78435fd8-0cbc-4e8b-b45e-96d2714788e7/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=78435fd8-0cbc-4e8b-b45e-96d2714788e7",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      